import { FC, useContext, useMemo, useRef, useState } from "react";
// 方法
import { DragDropContext } from "./context/dragDropContext";
import { requestFullScreen, exitFullscreen, } from "../utils/utils";
// 常量
import { DropfullScreenProps } from "./interface";
import { LeftCircleOutlined, LogoutOutlined, RightCircleOutlined } from "@ant-design/icons";

/** 全屏播放 */
const DropfullScreen: FC<DropfullScreenProps> = props => {
  const { actionRef } = props;
  const [currentIndex, setCurrentIndex] = useState<number>();
  const { dragItems } = useContext(DragDropContext);
  const divRef = useRef<HTMLDivElement>(null);
  const fullDragItem = useMemo(() => {
    return dragItems.filter(item => item.fullScreen !== false);
  }, [dragItems]);
  /** 全屏 */
  const handleShow = (name: string) => {
    const fullScreenNode = divRef.current;
    if (fullScreenNode) {
      const findIndex = fullDragItem.findIndex(item => item.name === name);
      setCurrentIndex(findIndex);
      requestFullScreen(fullScreenNode);
    }
  };
  /** 上一个 */
  const handlePrev = () => {
    setCurrentIndex(prev => {
      if (prev === undefined) return 0;
      if (prev === 0) return (fullDragItem.length - 1);
      return prev - 1;
    });
  };
  /** 下一个 */
  const handleNext = () => {
    setCurrentIndex(prev => {
      if (prev === undefined) return 0;
      if (prev === (fullDragItem.length - 1)) return 0;
      return prev + 1;
    });
  };
  /** 退出全屏 */
  const handleExit = () => {
    setCurrentIndex(undefined);
    exitFullscreen();
  };
  const currentDragItem = useMemo(() => {
    if (currentIndex !== undefined) {
      return fullDragItem[currentIndex];
    }
  }, [fullDragItem, currentIndex]);
  actionRef.current = {
    show: handleShow,
  };

  return (
    <div ref={divRef} className="drag-drop-full-screen">
      <div className="full-screen-container">
        <div className="full-screen-container-header">
          <div className="header-left">
            <div className="header-left-title">{currentDragItem?.title}</div>
            <div className="header-left-desc">{currentDragItem?.description}</div>
          </div>
          <div className="header-right" onClick={handleExit}>
            <LogoutOutlined />
            <span className="p-l-s">退出全屏</span>
          </div>
        </div>
        <div className="full-screen-container-body">
          {
            currentDragItem?.container
          }
          <div className="body-operation body-operation-left" onClick={handlePrev}><LeftCircleOutlined /></div>
          <div className="body-operation body-operation-right" onClick={handleNext}><RightCircleOutlined /></div>
        </div>
      </div>
    </div>
  );
};

export default DropfullScreen;
